import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function AboutPage() {
  return (
    <>
      <SEOHead
        title="关于我们 - 韩漫之家品牌介绍与联系方式"
        description="了解韩漫之家——免费韩漫大全在线阅读平台。汇集海量韩国漫画资源，支持下拉式阅读，从经典到新作一应俱全。查看品牌介绍、平台信誉与联系方式。"
        keywords="韩漫之家, 韩漫平台介绍, 韩漫在线阅读, 免费韩国漫画, 联系我们"
        canonicalUrl="/about"
      />

      <div className="pt-16">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: "关于我们" },
              ]}
            />
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
              关于韩漫之家
            </h1>
            <p className="text-sm text-foreground-600 mb-10 leading-relaxed">
              韩漫之家是一个专注于免费韩漫阅读的在线平台，致力于为广大韩漫爱好者提供优质、便捷的在线阅读体验。
            </p>

            <div className="space-y-10">
              <div>
                <h2 className="text-xl font-semibold text-foreground-900 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                  品牌介绍
                </h2>
                <div className="bg-background-50 rounded-lg border border-background-200/70 p-6">
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    韩漫之家成立于2023年，是国内领先的韩漫在线阅读平台之一。我们深知韩漫爱好者对优质阅读体验的渴望，因此始终专注于为用户提供丰富、高清、更新及时的韩漫资源。
                  </p>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    平台收录了上千部韩国漫画作品，涵盖恋爱言情、奇幻冒险、热血动作、搞笑日常、悬疑惊悚、都市剧情、古风历史等多个分类。从现象级热门作品到小众精品，我们致力于打造最全面的韩漫书库。
                  </p>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    我们的阅读器支持流畅的下拉式阅读体验，无论是电脑端还是移动端，都能为您提供舒适、沉浸式的漫画浏览感受。所有漫画资源完全免费，无需任何付费订阅。
                  </p>
                </div>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground-900 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                  平台特色
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    { icon: "ri-book-read-line", title: "海量资源", desc: "上千部韩漫作品，持续更新扩充" },
                    { icon: "ri-thumb-up-line", title: "完全免费", desc: "所有漫画免费阅读，零门槛畅享" },
                    { icon: "ri-speed-line", title: "极速更新", desc: "同步韩国最新连载，每日准时更新" },
                    { icon: "ri-device-line", title: "多端适配", desc: "PC、平板、手机全平台无缝阅读" },
                    { icon: "ri-translate", title: "中文汉化", desc: "专业汉化团队，翻译质量有保障" },
                    { icon: "ri-shield-star-line", title: "安全无毒", desc: "纯净阅读环境，无弹窗无恶意广告" },
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70"
                    >
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                        <i className={`${item.icon} text-lg`}></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                        <p className="text-xs text-foreground-500">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground-900 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                  平台信誉
                </h2>
                <div className="bg-background-50 rounded-lg border border-background-200/70 p-6">
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
                    <div>
                      <div className="text-2xl font-bold text-primary-500 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                        500万+
                      </div>
                      <p className="text-xs text-foreground-500">月活跃用户</p>
                    </div>
                    <div>
                      <div className="text-2xl font-bold text-primary-500 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                        2000+
                      </div>
                      <p className="text-xs text-foreground-500">收录漫画作品</p>
                    </div>
                    <div>
                      <div className="text-2xl font-bold text-primary-500 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                        99.7%
                      </div>
                      <p className="text-xs text-foreground-500">用户好评率</p>
                    </div>
                  </div>
                  <div className="mt-6 pt-6 border-t border-background-200/70">
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      韩漫之家始终坚持"以用户为中心"的运营理念。我们与多家韩国漫画版权方建立了良好的合作关系，确保平台内容的合法性与正版性。同时，我们的汉化团队由资深韩语翻译和漫画爱好者组成，每一部作品的翻译都经过严格的质量把控。
                    </p>
                    <p className="text-sm text-foreground-700 leading-relaxed mt-3">
                      自上线以来，平台获得了广大韩漫爱好者的一致好评。我们持续优化阅读体验，完善功能设计，努力为每一位用户打造最好的韩漫阅读家园。
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground-900 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                  常见问题
                </h2>
                <div className="space-y-3">
                  {[
                    { q: "韩漫之家的漫画资源是否完全免费？", a: "是的，韩漫之家所有漫画资源均免费提供阅读，无需任何付费或订阅。我们致力于让每一位韩漫爱好者都能无障碍地享受阅读乐趣。" },
                    { q: "漫画更新频率是怎样的？", a: "我们与韩国漫画平台保持同步更新，热门连载作品通常每日更新一话。您可以在「最近更新」栏目中查看最新上线的章节。" },
                    { q: "支持哪些设备阅读？", a: "韩漫之家采用响应式设计，完美适配PC电脑、平板和手机等各类设备。在移动端，我们特别优化了下拉式阅读体验，让您随时随地畅享韩漫。" },
                    { q: "如何找到我想看的漫画？", a: "您可以通过首页的分类导航浏览不同类型的漫画，也可以使用搜索功能直接查找作品名称。热门推荐和排行榜也能帮助您发现优质内容。" },
                    { q: "遇到问题如何联系客服？", a: "您可以通过下方联系方式中的邮箱或QQ联系我们的客服团队，我们会在24小时内回复您的咨询。" },
                  ].map((faq, index) => (
                    <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                      <summary className="flex items-center justify-between p-4 cursor-pointer hover:bg-background-100 transition-colors">
                        <span className="text-sm font-medium text-foreground-900 pr-4">{faq.q}</span>
                        <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                      </summary>
                      <div className="px-4 pb-4">
                        <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                      </div>
                    </details>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground-900 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                  联系我们
                </h2>
                <div className="bg-background-50 rounded-lg border border-background-200/70 p-6">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                        <i className="ri-mail-line text-lg"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                        <p className="text-sm text-foreground-600">contact@hanmanzhijia.com</p>
                        <p className="text-xs text-foreground-400 mt-1">商务合作 / 版权事务</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                        <i className="ri-qq-line text-lg"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-900 mb-1">客服QQ</h3>
                        <p className="text-sm text-foreground-600">1234567890</p>
                        <p className="text-xs text-foreground-400 mt-1">在线时间：工作日 9:00-18:00</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                        <i className="ri-wechat-line text-lg"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</h3>
                        <p className="text-sm text-foreground-600">韩漫之家官方</p>
                        <p className="text-xs text-foreground-400 mt-1">关注获取每日更新推送</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                        <i className="ri-weibo-line text-lg"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-900 mb-1">官方微博</h3>
                        <p className="text-sm text-foreground-600">@韩漫之家</p>
                        <p className="text-xs text-foreground-400 mt-1">最新资讯与粉丝互动</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "AboutPage",
              name: "关于韩漫之家",
              description: "了解韩漫之家——免费韩漫大全在线阅读平台。汇集海量韩国漫画资源，支持下拉式阅读。",
              publisher: {
                "@type": "Organization",
                name: "韩漫之家",
              },
            }),
          }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: [
                { "@type": "Question", name: "韩漫之家的漫画资源是否完全免费？", acceptedAnswer: { "@type": "Answer", text: "是的，韩漫之家所有漫画资源均免费提供阅读，无需任何付费或订阅。" } },
                { "@type": "Question", name: "漫画更新频率是怎样的？", acceptedAnswer: { "@type": "Answer", text: "我们与韩国漫画平台保持同步更新，热门连载作品通常每日更新一话。" } },
                { "@type": "Question", name: "支持哪些设备阅读？", acceptedAnswer: { "@type": "Answer", text: "韩漫之家采用响应式设计，完美适配PC电脑、平板和手机等各类设备。" } },
                { "@type": "Question", name: "如何找到我想看的漫画？", acceptedAnswer: { "@type": "Answer", text: "您可以通过首页的分类导航浏览不同类型的漫画，也可以使用搜索功能直接查找作品名称。" } },
                { "@type": "Question", name: "遇到问题如何联系客服？", acceptedAnswer: { "@type": "Answer", text: "您可以通过邮箱或QQ联系我们的客服团队，我们会在24小时内回复。" } },
              ],
            }),
          }}
        />
      </div>
    </>
  );
}